module.exports = __webpack_public_path__ + "img/1.59bd98f9.jpg";